import React, { useCallback, useEffect, useState } from 'react'
import ChatRoom from './ChatRoom'
import ChatPrompt from '../../../ChatBox/ChatPrompt'
import { localFileUpload } from '../../../common/checks_Func'
import UploadedImagesDisplay from '../../../Create/UploadedImagesDisplay'
import { useDispatch, useSelector } from 'react-redux'
import { userInfo } from '../../../../redux/Selectors/selectors'
import { useParams } from 'react-router-dom'
import { postDebateArgument } from '../../../../redux/Thunks/debatesThunk'
import Participation from './Participation'

const DebateUpdate = ({ debateData }) => {

  const loggedInUser = useSelector(userInfo)
  const dispatch = useDispatch()

  const { debate_id } = useParams()

  const [text, setText] = useState("")
  const [media, setMedia] = useState([])
  const [error, setError] = useState("")
  const [side, setSide] = useState(null)

  const [isTyping, setIsTyping] = useState(false)


  const handleFile = (e) => {

    const validatedFiles = localFileUpload(e, setError, true)
    setIsTyping(true)

    if (media.length > 0) {
      setMedia((prevValue) => {
        return [...validatedFiles, ...prevValue]
      });
    } else {
      setMedia(validatedFiles)
    }

  };


  function removeMediaFromList(index) {
    setMedia(media.filter((_, idx) => {
      return idx !== index
    }))
  }

  const submitComment = (e) => {
    e.preventDefault()

    const body = {
      author: loggedInUser?.id,
      media,
      side,
      text,
      debate_id
    }

    if (!text && !media) {
      setError("Text cannot be empty!")
      return
    }
    setIsTyping("No")
    dispatch(postDebateArgument(body))
    setText("")
    setMedia([])

  }

  const getSide = useCallback(() => {
    setSide(null)
    const supportingData = debateData?.supporting || []
    const opposingData = debateData?.opposing || []

    const supportingSide = supportingData.length > 0 && supportingData.find(({ id }) => {
      return id === loggedInUser?.id
    })

    const opposingSide = opposingData.length > 0 && opposingData.find(({ id }) => {
      return id === loggedInUser?.id
    })


    if (supportingSide) {
      setSide("supports")
    } else if (opposingSide) {
      setSide("opposes")
    }

  }, [debateData, loggedInUser])


  useEffect(() => {
    getSide()
  }, [getSide, debate_id])

  return (
    <div className='bg-[#101010] rounded-lg w-full lg:w-[50%] '>
      <div className='p-2 m-2 md:p-5 md:m-5'>
        <h1 className='font-bold font-nunito text-base md:text-3xl'>Debate Updates</h1>
      </div>
      <div className='relative p-2 md:p-5 md:m-2'>
        <ChatRoom debateId={debate_id} />

        {side &&
          <div>
            <Participation
              userDetails={loggedInUser}
              textLength={text.length}
              mediaLength={media.length}
              debateId={debate_id}
              isUserTyping={isTyping}
            />
            <ChatPrompt
              currentMode={true}
              bgOnDark="bg-[#101010]"
              position="static"
              placeholder="Write your points here..."
              submitPrompt={submitComment}
              value={text}
              handleChange={(e) => {
                setText(e.target.value)
                setIsTyping(true)
              }}
              showFileBTn={true}
              selectFile={handleFile}
              id="debateArgument"
              mediaPresent={media.length > 0 && true}
            />
            <p className='m-3 text-red-600 text-sm'>{error}</p>


            <div>
              <UploadedImagesDisplay media={media} removeMedia={removeMediaFromList} />
            </div>
          </div>}



      </div>


    </div>
  )
}

export default DebateUpdate